<template lang="pug">
  .verify-account
    p.sign-in-title.kapra-neue.upper.xs-f-xgrande.max-at-tweak Welcome Back
    p.text-color-2.xs-f-small.max-at-tweak
      | Next step is to create your password but we just need to verify it's you first! We sent a verification email to&#32;
      span.user-email.semi-bold {{ userEmail }}
      | &#32;
      button.change-email.btn-reset.text-color-3.underline(@click="setView('signIn')") Change

    button.resend-cta.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(@click="magicLink") re-send the link

    p.please-allow.text-color-2.xs-f-xsmall.max-at-tweak Please allow up to 5 minutes for the verification link to be sent before requesting a new one.

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import { sendMagicLink } from "@services/vueCustomerSvc";

  export default {
    name: "VerifyAccount",

    computed: {
      ...mapState('signIn', [
        'processing',
        'userEmail',
      ]),
    },

    methods: {
      ...mapActions([
        'notifyError',
      ]),

      ...mapMutations('signIn', [
        'setProcessing',
        'setView',
      ]),

      magicLink() {
        if (this.processing) {
          return;
        }

        this.setProcessing(true);

        sendMagicLink({ email: this.userEmail, view: 'createPassword' }).then(() => {
          this.trackMREvent('MrSignInV2 - Verify account magic link email sent', { email: this.userEmail });
          this.setProcessing(false);
        }).catch(err => {
          this.setProcessing(false);
          this.trackMREvent('MrSignInV2 - Verify account magic link email send failed', { email: this.userEmail });

          let error = err.response;
          let errorMessage = "";

          if (error.data) {
            if (error.data.message == "Invalid e-mail address") {
              setTimeout(() => {
                window.location = "/support";
              }, 4000);

              errorMessage = error.data.message + ", redirecting to support page, one moment.";
            } else if (error.data.code == "UNSUBSCRIBED") {
              errorMessage = "It looks like you might not be getting our emails. If you do not receive one shortly please contact Color Crew for assistance.";
            } else {
              errorMessage = error.data.message;
            }
          }

          this.notifyError(errorMessage);
        });
      }
    },

    mounted() {
      this.magicLink();
    }
  };
</script>

<style scoped lang="stylus">
  .verify-account
    .resend-cta
      margin-top 2em
      margin-bottom 1em
      
</style>
